export default {
  namespaced: true,

  state: {
    query: {
      salesStatus: [],
      assignedTo: [],
      order: '',
    },
  },
  getters: {
    apiQuery: state =>
      ({
        salesStatus: state.query.salesStatus.map(pp => (pp.value || pp)).join(','),
        assignedTo: state.query.assignedTo.map(pp => (pp.value || pp)).join(','),
        order: state.query.order,
      })
    ,
  },
  mutations: {
    salesStatus: (state, value) => state.query.salesStatus = value,
    assignedTo: (state, value) => state.query.assignedTo = value,
    order: (state, value) => state.query.order = value,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchJobList.js